<template>
  <v-dialog v-model="value" max-width="800" persistent>
    <v-overlay v-model="addEvent"></v-overlay>

    <v-card v-if="!addEvent">
      <v-card-title style="padding: 0">
        <v-toolbar color="transparent" density="compact">
          <v-toolbar-title class="text-h6" text="Добавить виджет"></v-toolbar-title>

          <template v-slot:append>
            <v-btn v-if="showWidgetSettings" size="small" icon="mdi-arrow-u-left-top"
              @click="showWidgetSettings = false"></v-btn>
            <v-btn size="small" icon="mdi-close" @click="$emit('update:modelValue', false)"></v-btn>
          </template>
        </v-toolbar>
      </v-card-title>
      <v-divider style="margin: 0" class="border-opacity-100"></v-divider>
      <v-card-text v-if="widgets.length">
        <!-- список иконок виджетов -->
        <div :class="!showWidgetSettings ? 'd-flex flex-row flex-wrap' : ''">
          <div :class="!showWidgetSettings ? 'px-2 v-col-sm-3 v-col-6' : ''
            " v-for="widget in widgets" :key="widget">
            <v-card :variant="showWidgetSettings ? 'text' : 'elevated'" style="cursor: pointer; height: 100%"
              @click="showWidgetSettings = widget">
              <component v-if="!showWidgetSettings || showWidgetSettings == widget" :is="widget" :ref="widget"
                :showWidgetSettings="showWidgetSettings" @widget-add="(event) => widgetAdd(event, widget)" />
            </v-card>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "addWidget",
  emits: ["update:modelValue", "widgetAdd"],
  props: {
    widgets: {
      required: true,
    },
    modelValue: {
      required: true,
    },
  },
  data() {
    return {
      showWidgetSettings: false,
      addEvent: false
    };
  },
  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  created() { },
  methods: {
    widgetAdd(data, widget) {
      this.addEvent = true;
      this.axios
        .post(
          this.$model.wwwroot + "/procollege/psm_desktop2/addWidget",
          new URLSearchParams({
            widget: widget,
            data: data == undefined ? "" : JSON.stringify(data),
          })
        )
        .then((response) => {
          this.addEvent = false;
          this.showWidgetSettings = false;
          this.$emit("update:modelValue", false);
          this.$emit("widgetAdd", response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
<style lang="scss"></style>
